import { render, staticRenderFns } from "./digital_license.vue?vue&type=template&id=2e15beda&scoped=true&"
import script from "./digital_license.vue?vue&type=script&lang=js&"
export * from "./digital_license.vue?vue&type=script&lang=js&"
import style0 from "./digital_license.vue?vue&type=style&index=0&id=2e15beda&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e15beda",
  null
  
)

export default component.exports